var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAchievementWaterPositive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4246 13.4296C26.6662 15.1625 27.6783 16.7815 28.2787 18.7149C28.6621 19.9493 28.8774 21.3124 28.8774 22.9155C28.8774 27.0164 23.9342 32.1667 18.7787 32.1667C13.6231 32.1667 7.83179 28.2704 7.83179 22.2089C7.83179 16.148 11.7381 12.7454 13.1996 10.6268C14.0036 9.46135 17.3602 5.40111 18.2814 2.99999C18.2814 2.99999 23.7625 10.9595 25.4246 13.4296Z",
    fill: "url(#paint0_radial_2936_90769)",
    stroke: "#F9EED4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3523 21.7854C12.3523 21.7854 12.564 23.1272 13.4824 24.5398C14.4001 25.9518 15.601 26.7292 15.601 26.7292",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3523 21.7854C12.3523 21.7854 12.564 23.1272 13.4824 24.5398C14.4001 25.9518 15.601 26.7292 15.601 26.7292",
    stroke: "#F9EED4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2936_90769",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2856 32.1667) rotate(-128.891) scale(39.7241 89.4437)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9DDA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE7E1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchievementWaterPositive);
export default __webpack_public_path__ + "static/media/achievement-water-positive.35edd888d74be4299b3e3c5fd672ca89.svg";
export { ForwardRef as ReactComponent };